import { FC } from 'react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal, DealDTO } from 'modules/domain/deal/types'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { InputWrapper } from '../../../styled'
import { FormInput } from 'views/components/form/FormInput'
import { AButton } from 'views/components/Analytics'
import { labelPriceLogistics } from 'modules/utils/numbers/formatPriceLogistics'

type LogisticBodyProps = {
  deal: Deal
  dealRefetch: refetchFunc
  onClose: () => void
}

export const LogisticForm: FC<LogisticBodyProps> = ({ deal, dealRefetch, onClose }) => {
  const { t } = useTranslation('deal')
  const { formHandler, formProgress } = useAFormHandler('approveLogistics', { id: deal?.id })

  const formik = useFormik({
    initialValues: {
      price_logistics: deal.price_logistics,
      price_logistics_with_overload: deal.price_logistics_with_overload,
      price_carrier: deal.price_carrier,
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.patch<DealDTO>(endpoints.deal(deal.id), formik.values)
      },
      {
        onSuccess: async () => {
          await dealRefetch()
          onClose()
        },
        onError: (error) => {
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })
  return (
    <>
      <InputWrapper>
        <FormInput
          labelWidth={340}
          label={labelPriceLogistics(t('contractSign.price_carrier'))}
          field="price_carrier"
          type="number"
          formik={formik}
          size={'small'}
        />
        <FormInput
          labelWidth={340}
          label={labelPriceLogistics(t('contractSign.price_logistics'))}
          field="price_logistics"
          type="number"
          formik={formik}
          size={'small'}
        />
        <FormInput
          labelWidth={340}
          label={labelPriceLogistics(t('contractSign.price_logistics_with_overload'))}
          field="price_logistics_with_overload"
          type="number"
          formik={formik}
          size={'small'}
        />
      </InputWrapper>

      <AButton
        id="contactSignApprove"
        onClick={() => formik.submitForm()}
        color="primary"
        size="medium"
        progress={formProgress}
      >
        {t('common:save')}
      </AButton>
    </>
  )
}
